import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/tipologieintervento/Tipologieintervento.vue'),
		meta: {
			title: 'tipologieintervento',
			acl: 'section.tipologieintervento'
		}
	}
];

export default routes;